import React, { useState, useRef } from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AccordionProps,
  Typography,
  SxProps,
} from "@mui/material";

import Stack, { Row } from "@rui/Stack";

interface WorkspaceSettingsAccordionProps extends AccordionProps {
  title: string;
  subtitle?: string;
  sx?: SxProps;
}

const WorkspaceSettingsAccordion = ({
  children,
  title,
  subtitle,
  sx,
  ...props
}: WorkspaceSettingsAccordionProps) => {
  const accordionSummary = useRef<HTMLDivElement>(null);

  // Set the current expanded state (can be true or false depending on defaultExpanded prop)
  const [expanded, setExpanded] = useState<boolean>(
    (accordionSummary.current &&
      accordionSummary?.current.classList.contains("Mui-expanded")) ??
      false
  );

  return (
    <Accordion
      sx={{
        boxShadow: 0,
        width: "100%",
        borderColor: "shades.neutral.100",
        borderRadius: 0,
        "&.Mui-expanded": { my: 0 },
      }}
      {...props}
    >
      <AccordionSummary
        expandIcon={
          <KeyboardArrowDownIcon sx={{ color: "shades.primary.500" }} />
        }
        sx={{
          height: "70px",
          "&.Mui-expanded": {
            backgroundColor: "shades.ghost.300",
            borderTop: "1px solid",
            borderColor: "shades.neutral.100",
          },
          ...sx,
        }}
        onClick={() => setExpanded(!expanded)}
        ref={accordionSummary}
      >
        <Row
          variant="apart"
          sx={{ width: "100%", minHeight: "62px", color: "shades.neutral.800" }}
        >
          <Stack spacing={0.5}>
            <Typography variant="h3">{title}</Typography>
            <Typography variant="bodySecondaryReg">{subtitle}</Typography>
          </Stack>
          <Typography
            variant="button"
            color="shades.primary.500"
            marginRight={1}
          >
            {expanded ? "Collapse" : "Expand"}
          </Typography>
        </Row>
      </AccordionSummary>
      <AccordionDetails sx={{ py: 2 }}>
        <Stack spacing={2}>{children}</Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default WorkspaceSettingsAccordion;
